// Generado por scripts/write-build-info.mjs: no editar.
export const BUILD_INFO = {
  commitHash: "dev",
  buildTime: "2026-11-05T13:22:41.062Z",
  apiBaseUrl: "https://618.dev.tec.movilidad.t2.cloud.technit.solutions/api/v1/",
} as const;
